"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ganttlab_entities_1 = require("ganttlab-entities");
var ViewMilestoneGitHubStrategy_1 = require("./strategies/ViewMilestoneGitHubStrategy");
var ViewMilestoneGitLabStragety_1 = require("./strategies/ViewMilestoneGitLabStragety");
var ViewMilestone = /** @class */ (function (_super) {
    __extends(ViewMilestone, _super);
    function ViewMilestone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.slug = 'milestone';
        _this.name = 'By milestone';
        _this.shortDescription = 'Issues in project/repo milestones';
        _this.slugStrategies = {
            github: new ViewMilestoneGitHubStrategy_1.ViewMilestoneGitHubStrategy(),
            gitlab: new ViewMilestoneGitLabStragety_1.ViewMilestoneGitLabStrategy(),
        };
        _this.configuration = {
            project: null,
            activeMilestone: 0,
            tasks: {
                page: 1,
                pageSize: 50,
            },
            milestones: {
                page: 1,
                pageSize: 50,
            },
        };
        return _this;
    }
    ViewMilestone.prototype.setSort = function (sort) {
        throw new Error('Method not implemented.');
    };
    ViewMilestone.prototype.reverseSort = function () {
        throw new Error('Method not implemented.');
    };
    ViewMilestone.prototype.setFilter = function (filter) {
        throw new Error('Method not implemented.');
    };
    return ViewMilestone;
}(ganttlab_entities_1.SourceVisitor));
exports.ViewMilestone = ViewMilestone;
//# sourceMappingURL=ViewMilestone.js.map